import api from './api';

export const getProfile = async (payload) =>
  await api.get(`/v1/people/${payload}`);
